module.exports = __webpack_public_path__ + "static/img/rank_230.9e2cd0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_230.png
// module id = QIuT
// module chunks = 1